var _defs, _polygon, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThunder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_6",
    "data-name": "Layer 6",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ffbb19;\n      }\n\n      .cls-2 {\n        fill: #9ec5fb;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "20.2 15.38 14.8 15.38 11.73 23.02 14.8 23.02 11.94 29.33 14.96 25.96 20.17 20.27 16.64 20.27 20.2 15.38"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M25.33,10.63c-.38,0-.74,.07-1.08,.17,0-.06,0-.11,0-.17,0-4.4-3.57-7.97-7.97-7.97-3.71,0-6.83,2.55-7.71,5.99-.3-.05-.6-.09-.91-.09-2.77,0-5.02,2.25-5.02,5.02,0,2.49,1.83,4.7,4.21,5.09h.04s9.41,0,9.41,0c0,0,0,0,0,0s0,0,0,0h8.55c.2,0,.35,0,.46,0,2.21,0,3.98-1.83,3.98-4.04s-1.79-4-4-4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThunder);
export default __webpack_public_path__ + "static/media/thunder.ed2df552f2df10a4a668aeef9d6032bf.svg";
export { ForwardRef as ReactComponent };